import idMichel from "../../../assets/img/img-bureau/idMichel.png";
import idYvan from "../../../assets/img/img-bureau/idYvan.png";
import idCharlotte from "../../../assets/img/img-bureau/idCharlotte.png";
import idJeremie from "../../../assets/img/img-bureau/idJeremie.png";
import idLaurence from "../../../assets/img/img-bureau/idLaurence.png";
import idMagaly from "../../../assets/img/img-bureau/idMagaly.png";
import idFX from "../../../assets/img/img-bureau/idFX.png";
import idFlorian from "../../../assets/img/img-bureau/idFlorian.png";

const tabBureau = [
  {
    id: 0,
    name: "Michel CEDDIA",
    position: "Président",
    phone: "06.82.94.80.94",
    commission: "Toutes",
    photoId: idMichel,
    userId: "ceddiam@aol.com",
  },
  {
    id: 1,
    name: "Yvan BESSON",
    position: "Vice-Président",
    phone: "06.17.91.26.36",
    commission: "Toutes",
    photoId: idYvan,
    userId: "yvan.besson@wanadoo.fr",
  },
  {
    id: 2,
    name: "Charlotte CATHERIN",
    position: "Secrétaire Générale",
    phone: "06.31.39.71.42",
    commission: "Tennis Féminin",
    photoId: idCharlotte,
    userId: "charlotte.catherin@gmail.com",
  },
  {
    id: 3,
    name: "Jérémie CATHERIN",
    position: "Trésorier Général",
    phone: "06.21.78.60.43",
    commission: "Toutes",
    photoId: idJeremie,
    userId: "jeremie.catherin@gmail.com",
  },
  {
    id: 4,
    name: "Laurence CEDDIA",
    position: "Trésorière Adjointe",
    phone: "06.59.77.38.69",
    commission: "Tennis Féminin",
    photoId: idLaurence,
    userId: "laurenceceddia@aol.com",
  },
  {
    id: 5,
    name: "Magaly LAMPIS",
    position: "Membre",
    phone: "06.60.84.73.95",
    commission: "Animations",
    photoId: idMagaly,
    userId: "maggyfx@gmail.com",
  },
  {
    id: 6,
    name: "François-Xavier GATINET",
    position: "Membre",
    phone: "06.60.85.07.50",
    commission: "Jeunes",
    photoId: idFX,
    userId: "fxparisien71@hotmail.fr",
  },
  {
    id: 7,
    name: "Florian CHAMBARD",
    position: "Membre",
    phone: "06.65.57.58.47",
    commission: "Animations",
    photoId: idFlorian,
    userId: "florian-david.chambard@hotmail.fr",
  },
];

export default tabBureau;
